import { profilesActions } from '../actions'
import ValidateFormObject from '../utils/ValidateFormObject'

const {
  ADD_PROFILE,
  CHANGE_ORDER_COLUMN,
  CHANGE_ORDER_DIRECTION,
  CHANGE_PAGE,
  CHANGE_PER_PAGE,
  CHANGE_PERMISSIONS,
  CHANGE_PROFILE,
  CLOSE_MODAL,
  DELETE_PROFILE,
  EDIT_PROFILE,
  FETCH_FUNCTIONALITIES_ERROR,
  FETCH_FUNCTIONALITIES,
  FETCH_PROFILE_ERROR,
  FETCH_PROFILE,
  FETCH_PROFILES_ERROR,
  FETCH_PROFILES,
  FETCHING_FUNCTIONALITIES,
  FETCHING_PROFILE,
  FETCHING_PROFILES,
  FORM_TOUCHED,
  NEW_FORM_PROFILE,
  OPEN_MODAL,
  PROFILE_FORM_ERROR,
  RESET_STATE
} = profilesActions

const getInitialState = () => ({
  loadingProfile: false,
  loadingProfiles: false,
  fetchProfileError: false,
  fetchProfilesError: false,
  profiles: [],
  order: {
    column: 'nome',
    direction: 1
  },
  profile: {
    nome: '',
    permissoes: {}
  },
  profilesPagination: {
    page: 0,
    rowsPerPage: 50,
    length: 0
  },
  profileFormErrors: {},
  profileFormTouched: false,
  modalOpen: false,
  functionalities: []
})

const profileSchema = {
  add: {
    nome: {
      required: true,
      minValue: 3
    }
  },
  edit: {
    nome: {
      required: true,
      minValue: 3
    }
  }
}

const ProfileValidate = new ValidateFormObject(profileSchema)

const profiles = (state = getInitialState(), action = {}) => {
  let formSchemaType

  switch (action.type) {
    case CHANGE_PERMISSIONS:
      const { permissoes } = state.profile
      const { functionality, type, checked } = action.permission
      const { _id: funcionalidade, alias } = functionality

      const current = permissoes[alias] || { funcionalidade }

      if (['editar', 'remover'].includes(type) && checked) {
        current['ler'] = true
      } else if (type === 'ler' && !checked) {
        current['editar'] = false
        current['remover'] = false
      }

      permissoes[alias] = {
        ...current,
        [type]: checked
      }

      return {
        ...state,
        profile: {
          ...state.profile,
          permissoes
        }
      }

    case CHANGE_PROFILE:
      formSchemaType = action.profile._id ? 'edit' : 'add'

      return {
        ...state,
        profile: action.profile,
        profileFormErrors: ProfileValidate.validate({
          formObject: action.profile,
          formSchemaType
        })
      }

    case PROFILE_FORM_ERROR:
      const formErrors = {}

      formSchemaType = state.profile._id ? 'edit' : 'add'
      formErrors[action.field] = { valid: false, errorMessage: action.message }

      return {
        ...state,
        profileFormErrors: ProfileValidate.validate({
          formObject: state.profile,
          invalidFields: formErrors,
          formSchemaType
        })
      }

    case NEW_FORM_PROFILE:
      return {
        ...state,
        profile: { ...getInitialState().profile },
        profileFormErrors: ProfileValidate.validate({}),
        profileFormTouched: false
      }

    case FORM_TOUCHED:
      return {
        ...state,
        profileFormTouched: true
      }

    case CHANGE_ORDER_COLUMN:
      return {
        ...state,
        order: {
          direction: 1,
          column: action.column
        }
      }

    case CHANGE_ORDER_DIRECTION:
      return {
        ...state,
        order: {
          ...state.order,
          direction: action.direction
        }
      }

    case OPEN_MODAL:
      return {
        ...state,
        modalOpen: true
      }

    case CLOSE_MODAL:
      return {
        ...state,
        modalOpen: false
      }

    case FETCH_PROFILE:
      formSchemaType = (action.profile || {})._id ? 'edit' : 'add'

      return {
        ...state,
        profile: action.profile,
        loadingProfile: false,
        fetchprofileError: false,
        profileFormTouched: false,
        profileFormErrors: ProfileValidate.validate({
          formObject: action.profile,
          formSchemaType
        })
      }

    case FETCHING_PROFILE:
      return {
        ...state,
        loadingProfile: true,
        fetchProfileError: false
      }

    case DELETE_PROFILE:
      return {
        ...state,
        loadingProfiles: false,
        fetchProfileError: false,
        profiles: state.profiles.map(profile => {
          if (profile._id === action.profile._id) {
            profile = action.profile
          }

          return profile
        })
      }

    case FETCH_PROFILE_ERROR:
      return {
        ...state,
        loadingProfile: false,
        profile: { ...getInitialState().profile },
        fetchProfileError: action.error
      }

    case CHANGE_PAGE:
      return {
        ...state,
        profilesPagination: {
          ...state.profilesPagination,
          page: action.page
        }
      }

    case CHANGE_PER_PAGE:
      return {
        ...state,
        profilesPagination: {
          ...state.profilesPagination,
          rowsPerPage: action.perPage
        }
      }

    case FETCH_PROFILES:
      return {
        ...state,
        loadingProfiles: false,
        profiles: action.profiles,
        fetchProfilesError: false,
        order: action.order,
        profilesPagination: {
          length: action.length,
          page: action.page,
          rowsPerPage: action.rowsPerPage
        }
      }

    case EDIT_PROFILE:
      return {
        ...state,
        profiles: state.profiles.map(profile => {
          if (profile._id === action.profile._id) {
            return action.profile
          }

          return profile
        }),
        loadingProfiles: false,
        fetchProfileError: false,
        loadingProfile: false,
        fetchProfilesError: false
      }

    case FETCHING_PROFILES:
      return {
        ...state,
        loadingProfiles: true,
        fetchProfilesError: false
      }

    case FETCH_PROFILES_ERROR:
      return {
        ...state,
        loadingProfiles: false,
        fetchProfileError: action.error,
        loadingProfile: false
      }

    case ADD_PROFILE:
      return {
        ...state,
        loadingProfiles: false,
        fetchProfileError: false,
        loadingProfile: false,
        profiles: [...state.profiles, action.profile]
      }

    case RESET_STATE:
      return getInitialState()

    case FETCHING_FUNCTIONALITIES:
      return {
        ...state,
        loadingProfiles: true,
        fetchProfilesError: false
      }

    case FETCH_FUNCTIONALITIES:
      const { functionalities } = action

      return {
        ...state,
        functionalities
      }

    case FETCH_FUNCTIONALITIES_ERROR:
      return {
        ...state,
        loadingProfiles: false,
        fetchProfileError: action.error,
        loadingProfile: false,
        functionalities: []
      }

    default:
      return state
  }
}

export default profiles



// WEBPACK FOOTER //
// ./src/reducers/profiles.js